import * as yup from 'yup'

export const MobileValidation = yup
  .string()
  .matches(/^(\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/, {
    message: 'Please enter a valid phone number',
  })
